module.exports = __webpack_public_path__ + "img/icon_link_share_b.27df0cf0.svg";